import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  IconButton 
} from '@mui/material';
import DeleteIcon from "../../../../../../../styles/svg/delete.svg";
import moment from 'moment';
import PdfIcon from "../../../../../../../styles/svg/pdf-icon.svg";
import ViewIcon from "../../../../../../../styles/svg/view.svg";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteHPDDocument } from '../../../../../../../sevices/violationsApi';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import DeleteConfirmationDialog from './DeleteConfirmationDialog';
import { isAdmin } from '../../../../../../../utils/helpers';

const DocumentCard = ({ document }) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const { id } = useParams();
  const queryClient = useQueryClient();
  
  const { mutate: deleteDocument, isPending } = useMutation({
    mutationFn: (id) => deleteHPDDocument(id),
    onSuccess: () => {
      toast.success("Document deleted successfully");
      queryClient.invalidateQueries({ queryKey: ['hpd-ticket', id] });
      setShowConfirmation(false);
    },
    onError: () => {
      toast.error("Failed to delete document");
      setShowConfirmation(false);
    },
  });

  const handleDeleteClick = () => {
    setShowConfirmation(true);
  };

  const handleConfirmDelete = () => {
    deleteDocument(document.attachment_id);
  };

  const handleCancelDelete = () => {
    setShowConfirmation(false);
  };

  const handleViewClick = () => {
    window.open(
      `${process.env.REACT_APP_BASE_URL}/violation/${document.file_path}`,
      "_blank"
    );
  };

  return (
    <>
      <Paper className="document-card">
        <Box className="document-card-content">
          <img src={PdfIcon} alt="document" className="document-icon" />
          <Typography variant="body1" className="document-name">
            {document.description}
          </Typography>
          <Typography variant="body2" className="document-date">
            {moment(document.date).format("MM/DD/YYYY")}
          </Typography>
          <Box className="document-actions">
            <IconButton size="small" className="view-document" onClick={handleViewClick}>
              <img src={ViewIcon} alt="view" />
            </IconButton>
           {isAdmin() && <IconButton 
              size="small" 
              className="delete-document" 
              onClick={handleDeleteClick}
              disabled={isPending}
            >
              <img src={DeleteIcon} alt="delete" />
            </IconButton>}
          </Box>
        </Box>
      </Paper>

      {/* Confirmation Dialog */}
      <DeleteConfirmationDialog
        open={showConfirmation}
        handleClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        documentName={document.description}
        isLoading={isPending}
      />
    </>
  );
};

export default DocumentCard; 